// "use client"      this change  

import { useEffect, useRef, useState } from "react"
import { Link, useLocation } from "react-router-dom"
import { IoReorderThreeOutline, IoClose, IoArrowForward, IoChevronDown } from "react-icons/io5"
import synergy from "./../../../Assets/synergy-logo-main.png"
import "./Navbarsynergtech.css"

export const SERVICE_LINKS = [
  { to: "/custom-software-development", label: "Custom Software Development" },
  { to: "/software-engineering", label: "Software Engineering" },
  { to: "/generative-ai", label: "Generative AI" },
  { to: "/machine-learning", label: "Machine Learning" },
  { to: "/data-engineering", label: "Data Engineering" },
  { to: "/cloud-engineering", label: "Cloud Engineering" },
  { to: "/digital-commerce", label: "Digital Commerce" },
  { to: "/crm-platform-implementation", label: "CRM Implementation" },
  { to: "/rpa-ipa-implementation", label: "RPA & IPA Implementation" },
  { to: "/system-integration", label: "System Integration" },
  { to: "/product-strategy-consulting", label: "Product Strategy & Consulting" },
  { to: "/graphics-designing", label: "Graphics Designing" },
]

const Navbarsynergtech = () => {
  const location = useLocation()
  const [isNavOpen, setIsNavOpen] = useState(false)
  const [isServicesOpen, setIsServicesOpen] = useState(false)
  const servicesRef = useRef(null)
  // Slightly more compact, stronger-shadowed header once the page has scrolled (false on first render, so the
  // prerendered HTML and the first client render match).
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 8)
    onScroll()
    window.addEventListener("scroll", onScroll, { passive: true })
    return () => window.removeEventListener("scroll", onScroll)
  }, [])

  // Close the Services dropdown on Escape or on a click/tap outside it. Escape also drops
  // keyboard focus out of the menu so the desktop :focus-within rule stops showing it.
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key !== "Escape") return
      setIsServicesOpen(false)
      const el = servicesRef.current
      if (el && el.contains(document.activeElement)) document.activeElement.blur()
    }
    const handlePointerDown = (e) => {
      if (servicesRef.current && !servicesRef.current.contains(e.target)) setIsServicesOpen(false)
    }
    document.addEventListener("keydown", handleKeyDown)
    document.addEventListener("mousedown", handlePointerDown)
    document.addEventListener("touchstart", handlePointerDown)
    return () => {
      document.removeEventListener("keydown", handleKeyDown)
      document.removeEventListener("mousedown", handlePointerDown)
      document.removeEventListener("touchstart", handlePointerDown)
    }
  }, [])

  const handleNavClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    setIsNavOpen(false)
    setIsServicesOpen(false)
  }

  const toggleNavbar = () => {
    setIsNavOpen(!isNavOpen)
  }

  const servicesActive =
    location.pathname === "/services" || SERVICE_LINKS.some((service) => service.to === location.pathname)

  const closeNavbar = () => {
    setIsNavOpen(false)
  }

  return (
    <div className={`main_div_sticky ${isScrolled ? "is-scrolled" : ""}`}>
      <nav className="navbar navbar-expand-xl p-0 m-0">
        <div className="navbar-brand">
       <a href="/" onClick={() => window.location.reload()} className="logo-link">
  <img src={synergy || "/placeholder.svg"} width="250" height="90" className="synergytech_logo" alt="360 SynergyTech logo" />
</a>

        </div>

        <button
          className={`navbar-toggler ${isNavOpen ? "is-open" : ""}`}
          type="button"
          onClick={toggleNavbar}
          aria-controls="navbarSupportedContent"
          aria-expanded={isNavOpen}
          aria-label="Toggle navigation"
        >
          {isNavOpen ? <IoClose /> : <IoReorderThreeOutline />}
        </button>

        {isNavOpen && <div className="navbar-overlay" onClick={closeNavbar} />}

        <div className={`navbar-collapse ${isNavOpen ? "show" : "collapse"}`} id="navbarSupportedContent" style={{ maxHeight: isNavOpen ? '100vh' : '0' }}>
    
          <ul className="navbar-nav mr-auto">
            <li className="nav-item">
              <Link
                to="/"
                className={`navitems_synergytechnavbar ${location.pathname === "/" ? "active" : ""}`}
                onClick={handleNavClick}
              >
                Home
              </Link>
            </li>
            <li ref={servicesRef} className={`nav-item nav-dropdown ${isServicesOpen ? "open" : ""}`}>
              <div className="nav-dropdown-row">
                <Link
                  to="/services"
                  className={`navitems_synergytechnavbar ${servicesActive ? "active" : ""}`}
                  onClick={handleNavClick}
                >
                  Services
                </Link>
                <button
                  type="button"
                  className="nav-dropdown-toggle"
                  aria-label="Toggle services menu"
                  aria-expanded={isServicesOpen}
                  onClick={() => setIsServicesOpen(!isServicesOpen)}
                >
                  <IoChevronDown />
                </button>
              </div>
              <ul className="nav-dropdown-menu">
                {SERVICE_LINKS.map((service) => (
                  <li key={service.to}>
                    <Link
                      to={service.to}
                      className={`nav-dropdown-link ${location.pathname === service.to ? "active" : ""}`}
                      onClick={handleNavClick}
                    >
                      {service.label}
                    </Link>
                  </li>
                ))}
                <li className="nav-dropdown-all-item">
                  <Link to="/services" className="nav-dropdown-link nav-dropdown-all" onClick={handleNavClick}>
                    View all services
                    <IoArrowForward aria-hidden="true" />
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <Link
                to="/portfolio"
                className={`navitems_synergytechnavbar ${location.pathname === "/portfolio" ? "active" : ""}`}
                onClick={handleNavClick}
              >
                Portfolio
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/case-studies"
                className={`navitems_synergytechnavbar ${location.pathname === "/case-studies" ? "active" : ""}`}
                onClick={handleNavClick}
              >
                Case Studies
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/about"
                className={`navitems_synergytechnavbar ${location.pathname === "/about" ? "active" : ""}`}
                onClick={handleNavClick}
              >
                About
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/team"
                className={`navitems_synergytechnavbar ${location.pathname === "/team" ? "active" : ""}`}
                onClick={handleNavClick}
              >
                Team
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/blog"
                className={`navitems_synergytechnavbar ${location.pathname === "/blog" ? "active" : ""}`}
                onClick={handleNavClick}
              >
                Blog
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/careers"
                className={`navitems_synergytechnavbar ${location.pathname === "/careers" ? "active" : ""}`}
                onClick={handleNavClick}
              >
                Careers
              </Link>
            </li>
          </ul>

          <div className="form-inline">
            <Link to="/contact" className="btn_request_quote" onClick={handleNavClick}>
            Contact Us
            <IoArrowForward className="btn_request_quote_arrow" />
          </Link>
          </div>
         </div>
       </nav>
    </div>
  )
}

export default Navbarsynergtech;